import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './Pagination.less';
import { PageNavButton } from './Pagination.styles';

// Controlled by the parent's offset/limit so it always reflects the page actually shown.
export const Pagination = ({ deviceCount, onActionClick, limit = 10, offset = 0 }) => {
  const trans = useSelector(translator);
  const totalPages = Math.max(1, Math.ceil(deviceCount / limit));
  const currentPage = Math.min(Math.floor(offset / limit) + 1, totalPages);

  const onPageChange = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onActionClick(null, null, (page - 1) * limit, limit)();
  };

  const onLimitChange = (newLimit) => {
    onActionClick(null, null, 0, newLimit)();
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          type="button"
          className={`page ${i === currentPage ? 'active' : ''}`}
          aria-current={i === currentPage ? 'page' : undefined}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  return (
    <div className="pagination">
      <PageNavButton
        type="button"
        className={`prev ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &lt;
      </PageNavButton>
      {renderPageNumbers()}
      <PageNavButton
        type="button"
        className={`next ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &gt;
      </PageNavButton>
      <select
        className="pagination-select"
        value={limit}
        onChange={(e) => onLimitChange(parseInt(e.target.value))}
      >
        <option value={10}>{trans('10PAGE')}</option>
        <option value={20}>{trans('20PAGE')}</option>
        <option value={50}>{trans('50PAGE')}</option>
      </select>
    </div>
  );
};

Pagination.propTypes = {
  deviceCount: PropTypes.number,
  limit: PropTypes.number,
  offset: PropTypes.number,
  onActionClick: PropTypes.func,
};
export default Pagination;
